module.exports = __webpack_public_path__ + "static/media/sharepoint-integration.55870d9f.svg";